/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ActionsInputs */

const vi_common_actions = /** @type {(inputs: Common_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thao tác`)
};

/**

* @param {Common_ActionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_actions = /** @type {((inputs?: Common_ActionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ActionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_actions(inputs)
});